import {initializeApp} from 'firebase/app';
import {
  getToken as getFirebaseToken,
  getMessaging,
  onMessage,
} from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyBtFWfIKTTqON3GyKoRz6YevO5fUpbLmm4',
  authDomain: 'circulife-d8294.firebaseapp.com',
  projectId: 'circulife-d8294',
  storageBucket: 'circulife-d8294.appspot.com',
  messagingSenderId: '292349656091',
  appId: '1:292349656091:web:58cce2e7346e8f9fc7ccbe',
};

const firebaseApp = initializeApp(firebaseConfig);

const messaging = getMessaging(firebaseApp);

const {REACT_APP_VAPID_KEY} = process.env;
const publicKey = REACT_APP_VAPID_KEY;

export const getToken = async () => {
  let currentToken = '';
  try {
    currentToken = await getFirebaseToken(messaging, {vapidKey: publicKey});
  } catch (error) {
    console.log('An error occurred while retrieving token. ', error);
  }

  return currentToken;
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    return onMessage(messaging, (payload: any) => {
      resolve(payload);
    });
  });
